var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumnetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.8576 10.0578H0.228587C0.102338 10.0578 0 9.95548 0 9.82923V0.228587C0 0.102338 0.102338 0 0.228587 0H5.02891C5.08953 0 5.14768 0.0240931 5.19054 0.0669531L7.01924 1.89565C7.0621 1.93853 7.08619 1.99666 7.08619 2.05728V9.82923C7.08619 9.95548 6.98385 10.0578 6.8576 10.0578ZM0.457174 9.60064H6.62902V2.15196L4.93423 0.457174H0.457174V9.60064Z",
    fill: "#293D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.85721 2.28587H5.02851C4.90227 2.28587 4.79993 2.18353 4.79993 2.05728V0.228587C4.79993 0.102338 4.90227 0 5.02851 0C5.15476 0 5.2571 0.102338 5.2571 0.228587V1.82869H6.85721C6.98346 1.82869 7.08579 1.93103 7.08579 2.05728C7.08579 2.18353 6.98346 2.28587 6.85721 2.28587Z",
    fill: "#293D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.7721 10.9722H1.62312C1.49687 10.9722 1.39453 10.8699 1.39453 10.7437V9.8293C1.39453 9.70306 1.49687 9.60072 1.62312 9.60072C1.74937 9.60072 1.8517 9.70306 1.8517 9.8293V10.5151H7.54352V2.9717H6.85775C6.73151 2.9717 6.62917 2.86936 6.62917 2.74311C6.62917 2.61686 6.73151 2.51453 6.85775 2.51453H7.7721C7.89835 2.51453 8.00069 2.61686 8.00069 2.74311V10.7437C8.00069 10.8699 7.89835 10.9722 7.7721 10.9722Z",
    fill: "#293D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.94395 8.45791H1.14363C1.01738 8.45791 0.915039 8.35557 0.915039 8.22932C0.915039 8.10307 1.01738 8.00073 1.14363 8.00073H5.94395C6.0702 8.00073 6.17253 8.10307 6.17253 8.22932C6.17253 8.35557 6.0702 8.45791 5.94395 8.45791Z",
    fill: "#293D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.94395 7.5436H1.14363C1.01738 7.5436 0.915039 7.44126 0.915039 7.31501C0.915039 7.18876 1.01738 7.08643 1.14363 7.08643H5.94395C6.0702 7.08643 6.17253 7.18876 6.17253 7.31501C6.17253 7.44126 6.0702 7.5436 5.94395 7.5436Z",
    fill: "#293D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.94395 6.6288H1.14363C1.01738 6.6288 0.915039 6.52647 0.915039 6.40022C0.915039 6.27397 1.01738 6.17163 1.14363 6.17163H5.94395C6.0702 6.17163 6.17253 6.27397 6.17253 6.40022C6.17253 6.52647 6.0702 6.6288 5.94395 6.6288Z",
    fill: "#293D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.94395 5.71486H1.14363C1.01738 5.71486 0.915039 5.61253 0.915039 5.48628C0.915039 5.36003 1.01738 5.25769 1.14363 5.25769H5.94395C6.0702 5.25769 6.17253 5.36003 6.17253 5.48628C6.17253 5.61253 6.0702 5.71486 5.94395 5.71486Z",
    fill: "#293D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.94395 4.80031H1.14363C1.01738 4.80031 0.915039 4.69797 0.915039 4.57173C0.915039 4.44548 1.01738 4.34314 1.14363 4.34314H5.94395C6.0702 4.34314 6.17253 4.44548 6.17253 4.57173C6.17253 4.69797 6.0702 4.80031 5.94395 4.80031Z",
    fill: "#293D56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.20091 3.88601H1.14363C1.01738 3.88601 0.915039 3.78367 0.915039 3.65742C0.915039 3.53117 1.01738 3.42883 1.14363 3.42883H3.20091C3.32716 3.42883 3.42949 3.53117 3.42949 3.65742C3.42949 3.78367 3.32716 3.88601 3.20091 3.88601Z",
    fill: "#293D56"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumnetIcon);
export default __webpack_public_path__ + "static/media/DocumnetIcon.4a329a131051ccb24d3402546c2a2c56.svg";
export { ForwardRef as ReactComponent };